export const locationOptions = [
  { value: '', label: 'Destination (Any)', disabled: true, selected: true },
  { value: 'C', label: 'Caribbean' },
  { value: 'M', label: 'Mexico' },
  { value: 'BH', label: 'Bahamas' },
  { value: 'A', label: 'Alaska' },
  { value: 'E', label: 'Europe - All' },
  { value: 'H', label: 'Hawaii' },
  { value: 'BM', label: 'Bermuda' },
  { value: 'NN', label: 'Canada/New England/NY' },
  { value: '_', disabled: true, label: '-------------' },
  { value: 'ALL', label: 'All Destinations' },
  { value: 'A', label: 'Alaska - All' },
  { value: 'AG', label: 'Alaska - Gulf of Alaska' },
  { value: 'AR', label: 'Alaska - Inside Passage' },
  { value: 'AB', label: 'Antarctica' },
  { value: 'UN', label: 'Australia/New Zealand' },
  { value: 'BH', label: 'Bahamas' },
  { value: 'BM', label: 'Bermuda' },
  { value: 'NN', label: 'Canada/New England/NY' },
  { value: 'C', label: 'Caribbean - All' },
  { value: 'CE', label: 'Caribbean - Eastern' },
  { value: 'CS', label: 'Caribbean - Southern' },
  { value: 'CW', label: 'Caribbean - Western' },
  { value: 'CN', label: 'Cruise to Nowhere' },
  { value: 'E', label: 'Europe - All' },
  { value: 'EE', label: 'Europe - E. Mediterranean' },
  { value: 'R', label: 'Europe - Mediterranean - All' },
  { value: 'N', label: 'Europe - Northern' },
  { value: 'EW', label: 'Europe - W. Mediterranean' },
  { value: 'W', label: 'Europe - Western' },
  { value: 'O', label: 'Exotic - Asia/Africa/Other' },
  { value: 'H', label: 'Hawaii' },
  { value: 'M', label: 'Mexico' },
  { value: 'L', label: 'Pacific Coast' },
  { value: 'T', label: 'Panama Canal/C. America' },
  { value: 'S', label: 'South America' },
  { value: 'I', label: 'South Pacific - All' },
  { value: 'TH', label: 'South Pacific - Tahiti' },
  { value: 'ET', label: 'Transatlantic' },
  { value: 'NA', label: 'U.S. - All' },
  { value: 'RV', label: 'U.S. - American Rivers' },
  { value: 'WW', label: 'World Cruise' }
] as const

export const cruiseLineOptions = [
  { value: '', label: 'Cruise Line (Any)', disabled: true, selected: true },
  { value: 'ALL', label: 'All Cruise Lines' },
  { value: '92', label: 'AmaWaterways' },
  { value: '323', label: 'American Cruise Lines' },
  { value: '329', label: 'Avalon Waterways' },
  { value: '325', label: 'Azamara Cruises' },
  { value: '1', label: 'Carnival Cruise Lines' },
  { value: '11', label: 'Celebrity Cruises' },
  { value: '14', label: 'Costa Cruises' },
  { value: '369', label: 'Crystal Cruises' },
  { value: '18', label: 'Cunard' },
  { value: '20', label: 'Disney Cruise Line' },
  { value: '368', label: 'Explora Journeys' },
  { value: '24', label: 'Holland America Line' },
  { value: '71', label: 'MSC Cruises' },
  { value: '34', label: 'Norwegian Cruise Line' },
  { value: '67', label: 'Oceania Cruises' },
  { value: '344', label: 'Ponant' },
  { value: '40', label: 'Princess Cruises' },
  { value: '41', label: 'Regent Seven Seas Cruises' },
  { value: '44', label: 'Royal Caribbean' },
  { value: '375', label: 'Scenic Ocean Cruises' },
  { value: '50', label: 'Silversea Cruises' },
  { value: '48', label: 'The Yachts of Seabourn' },
  { value: '66', label: 'Uniworld River Cruises' },
  { value: '354', label: 'Viking Ocean Cruises' },
  { value: '78', label: 'Viking River Cruises' },
  { value: '364', label: 'Virgin Voyages' },
  { value: '64', label: 'Windstar Cruises' }
] as const

export const durationOptions = [
  { value: '', label: 'Cruise Length (Any)', disabled: true, selected: true },
  { value: 'ALL', label: 'All' },
  { value: '1', label: '1-2 Nights' },
  { value: '2', label: '3-5 Nights' },
  { value: '3', label: '6-8 Nights' },
  { value: '4', label: '9-11 Nights' },
  { value: '5', label: '12+ Nights' }
] as const

export const departurePortOptions = [
  { value: '', label: 'Departure Port (Any)', selected: true, disabled: true },
  { value: '_', disabled: true, label: 'U.S. Domestic Ports:' },
  { value: 'SWD', label: 'AK - Seward' },
  { value: 'WHIAK', label: 'AK - Whittier/Anchorage' },
  { value: 'LNBUS', label: 'CA - LA/Long Beach' },
  { value: 'SPDUS', label: 'CA - LA/San Pedro' },
  { value: 'SFO', label: 'CA - San Francisco' },
  { value: 'FLL', label: 'FL - Ft. Lauderdale' },
  { value: 'JAX', label: 'FL - Jacksonville' },
  { value: 'MIA', label: 'FL - Miami' },
  { value: 'PCV', label: 'FL - Port Canaveral' },
  { value: 'TPA', label: 'FL - Tampa' },
  { value: 'HNL', label: 'HI - Honolulu/Oahu' },
  { value: 'MSY', label: 'LA - New Orleans' },
  { value: 'BOS', label: 'MA - Boston' },
  { value: 'BWI', label: 'MD - Baltimore' },
  { value: 'BNJUS', label: 'NY - Bayonne/New Jersey' },
  { value: 'BLNUS', label: 'NY - Brooklyn' },
  { value: 'NYC', label: 'NY - New York' },
  { value: 'GAL', label: 'TX - Galveston' },
  { value: 'ORF', label: 'VA - Norfolk' },
  { value: 'SEA', label: 'WA - Seattle' },
  { value: '_', disabled: true, label: 'International Ports:' },
  { value: 'YQB', label: 'Canada - Quebec City, Q.C.' },
  { value: 'YVR', label: 'Canada - Vancouver, B.C.' },
  { value: 'CPH', label: 'Denmark - Copenhagen' },
  { value: 'QQD', label: 'England - Dover' },
  { value: 'LHR', label: 'England - London' },
  { value: 'STN', label: 'England - Southampton' },
  { value: 'PARFR', label: 'France - Paris' },
  { value: 'NURDE', label: 'Germany - Nuremberg' },
  { value: 'PIR', label: 'Greece - Piraeus/Athens' },
  { value: 'BUDHU', label: 'Hungary - Budapest' },
  { value: 'KEF', label: 'Iceland - Reykjavik' },
  { value: 'CIVIT', label: 'Italy - Rome/Civitavecchia' },
  { value: 'VCE', label: 'Italy - Venice' },
  { value: 'VLT', label: 'Malta - Valletta' },
  { value: 'MCM', label: 'Monaco - Monte Carlo' },
  { value: 'AMS', label: 'Netherlands - Amsterdam' },
  { value: 'BGO', label: 'Norway - Bergen' },
  { value: 'LIS', label: 'Portugal - Lisbon' },
  { value: 'SJU', label: 'Puerto Rico - San Juan' },
  { value: 'BCN', label: 'Spain - Barcelona' },
  { value: 'SKM', label: 'Sweden - Stockholm' },
  { value: 'BASCH', label: 'Switzerland - Basel' },
  { value: 'PPT', label: 'Tahiti - Papeete' },
  { value: 'IST', label: 'Turkey - Istanbul' }
] as const
